const initializerArg = {
  isSwitching: false,
  isDemo: false,
  isGreeted: false,
};

export { initializerArg };
